export const environment = {
  production: false,
  apiUrl: 'https://cal.cgm-medistar.cz/cal',
  siteKey: 'a5ee7056-15cc-4d34-9078-4158a874db2e',
};
